import printJS from 'print-js'
import { PDFDocument, rgb } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'

import TTFirsNeueUrl from '../assets/fonts/TTFirsNeue/TTFirsNeue-DemiBold.woff2'
const getTTFirsNeue = async () => await fetch(TTFirsNeueUrl).then((res) => res.arrayBuffer())

const titleStyles = {
  size: 14,
  color: rgb(0.3, 0.67, 0.34)
}

const signStyles = {
  size: 12,
  color: rgb(0.3, 0.67, 0.34)
}

const leftPadding = 32
const topPadding = 32

const titlePadding = 16
const signPadding = 8

export const printSignedPdf = async (document, documentUri) => {
  const {
    client_mime_type: mime,
    p7s,
    signatures
  } = document

  const signs = (p7s && p7s.length > 0 && p7s[0].attr.signatures) || signatures || []

  // load pdf or create with image
  const isJpeg = mime.includes('jpeg')
  const isPng = mime.includes('png')
  const isPdf = mime.includes('pdf')

  if (!isPdf && !isPng && !isJpeg) {
    throw new Error('Not supported file type for print')
  }

  const doc = await fetch(documentUri).then(res => res.arrayBuffer())

  const pdfDoc = isPdf
    ? await PDFDocument.load(doc)
    : await PDFDocument.create()

  // load our fonts
  pdfDoc.registerFontkit(fontkit)
  const TTFirsNeue = await pdfDoc.embedFont(await getTTFirsNeue())

  if (isJpeg || isPng) {
    const page = pdfDoc.addPage()
    const image = isJpeg
      ? await pdfDoc.embedJpg(doc)
      : await pdfDoc.embedPng(doc)

    const { width, height } = page.getSize()
    const scaled = image.scaleToFit(width, height)
    page.drawImage(image, {
      x: width - scaled.width,
      y: height - scaled.height,
      width: scaled.width,
      height: scaled.height
    })
  }

  // Sign pdf
  const pages = pdfDoc.getPages() // Get the first page of the document

  pages.forEach(page => {
    const { height } = page.getSize()
    const x = leftPadding
    let y = height - topPadding

    // Title
    if (signs.length > 0) {
      page.drawText('Документ підписано наступними особами:', { ...titleStyles, font: TTFirsNeue, x, y })
      y -= titleStyles.size + titlePadding
    }

    // Signatures
    signs.forEach(({
      signer_name: name,
      signer_drfou: code,
      certificate_serial_number: serial,
      signing_date_time: date
    }) => {
      page.drawText(`: ${name} ${code}`, { ...signStyles, font: TTFirsNeue, x, y }) // name
      y -= signStyles.size + signPadding
      page.drawText(`s/n: ${serial}`, { ...signStyles, font: TTFirsNeue, x, y }) // sn
      y -= signStyles.size + signPadding
      page.drawText(`Час підписання: ${date}`, { ...signStyles, font: TTFirsNeue, x, y }) // time
      y -= signStyles.size + signPadding
    })
  })

  // Print new pdf
  const newPdfBytes = await pdfDoc.save()
  const newPdfFile = new File([newPdfBytes], document.name)
  const newPdfUrl = window.URL.createObjectURL(newPdfFile)

  printJS({
    printable: newPdfUrl,
    type: 'pdf'
  })
}
